import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const routerMap = [ {
  path: '/',
  redirect: '/home'
},
{
  path: '/home',
  component: () => import('@/views/home')
},
{
  path: '/detail/:id',
  component: () => import('@/views/detail')
}]

export default new Router({
  routes: routerMap
})
